
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';


/**
 * Base UI Components to be imported, 
 * this mandatory to be included so that the View Module Pages can be rendered via baseUI
 */
import { BaseUIContainerComponent } from '../../../BaseFramework/base-ui/base-ui-container/base-ui-container.component'
import { AppLayoutComponent } from '../../../BaseFramework/base-ui/app-layout/app-layout.component'
////BASEUI Modules End

import { SearchIntimationComponent } from './search-intimation/search-intimation.component'
import { ClaimsAuthenticationGuard } from '../claims-guards'
import { IntimationBulkUploadComponent } from '../../shared-components/intimation-bulk-upload/intimation-bulk-upload.component';
import { NewBulkComponent } from '../../shared-components/new-bulk/new-bulk.component'
import { from } from 'rxjs';

var routeList = [
    {
        path: 'search',
        component: SearchIntimationComponent,
        data: {
            breadcrumb: 'Search Intimation',
            intimationType: 'NONBRANCH'
        },
    },
    {
        path: 'search-branch',
        component: SearchIntimationComponent,
        data: {
            breadcrumb: 'Search Branch Intimation',
            intimationType: 'BRANCH'
        },
    },
    {
        path: 'search-enquiry',
        component: SearchIntimationComponent,
        data: {
            breadcrumb: 'Search Intimation',
            viewType: 'ENQUIRY',
            intimationType: 'NONBRANCH'
        },
    },
    {
        path: 'bulkUpload',
        component: IntimationBulkUploadComponent,
        data: {
            breadcrumb: 'Intimation Bulk Upload',
            intimationType: 'NONBRANCH'
        },
    },
    {
        path: 'newBulk',
        component: NewBulkComponent,
        data: {
            breadcrumb: 'New Bulk',
            intimationType: 'NONBRANCH'
        },
    },


];

const routes: Routes = [
    ...routeList
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
    providers: []
})

export class IntimationRoutingModule { } 
